import React from 'react';
import { Box, Input, Flex } from '@chakra-ui/react';
import { Icon } from 'src/components/atoms/Icon';
import { InputGroup, InputLeftElement } from '@chakra-ui/react';

export const CampaignSearch: React.FC<{
  searchValue: string;
  onSearchChange: (value: string) => void;
  onSortToggle: () => void;
  sortOrder: 'asc' | 'desc' | null;
}> = ({ searchValue, onSearchChange, onSortToggle, sortOrder }) => {
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(e.target.value);
  };

  return (
    <Flex align="center" gap={2} h="32px" w="100%">
      <InputGroup size="sm">
        <InputLeftElement pointerEvents="none">
          <Icon iconName="search" width={3} height={3} color="content.muted" />
        </InputLeftElement>
        <Input
          placeholder="Campaign Name"
          value={searchValue}
          onChange={handleSearch}
          bg="surface.panel"
          border="1px solid"
          borderColor="surface.border"
          borderRadius="md"
          h="30px"
          pl={6}
          pr={2}
          fontSize="12px"
          fontWeight={600}
          color="content.label"
          _placeholder={{
            color: 'content.muted',
            fontWeight: 600,
            fontSize: '12px',
          }}
          _focus={{
            borderColor: 'icon.green',
            boxShadow: '0 0 0 1px var(--chakra-colors-icon-green)',
          }}
        />
      </InputGroup>
      <Box
        display="flex"
        flexDirection="column"
        gap={0}
        cursor="pointer"
        onClick={onSortToggle}
        _hover={{ opacity: 0.7 }}>
        <Icon
          iconName="chevron-up"
          width={3}
          height={3}
          color={sortOrder === 'asc' ? 'icon.green' : 'content.muted'}
        />
        <Icon
          iconName="chevron-down"
          width={3}
          height={3}
          color={sortOrder === 'desc' ? 'icon.green' : 'content.muted'}
        />
      </Box>
    </Flex>
  );
};
